import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { camelizeKeys } from "lib/helpers";
import messages from "../messages";

function* getHomeownerNotes(action) {
  const { leadId, isEnterprise } = action.payload || {};

  const { success, data, error } = yield* makeRequest.get(`/leads/${leadId}/homeowner_drawer_info`, {
    enterprise: isEnterprise,
  });

  if (success && data) {
    yield put(actions.setHomeownerNotes(camelizeKeys(data.body)));
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_FETCHING_HOMEOWNER_NOTES,
    });
  }
  return null;
}

export default getHomeownerNotes;
